export default {
	name: "Română",

	'global.itemCounts': `{total, plural,
		=0 {niciun conținut}
		other {}
	}{collections, plural,
		=0 {}
		one {o colecție}
		other {{collections} colecții}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {eine poveste}
		other {{stories} povești}
	}`,

	'cover.stories': `{itemCount, plural,
		one {poveste}
		other {povești}
	}`,

	'searchbutton.placeholder': 'căutare...',

	'flow.empty': 'Nu există conținut de afișat.',

	'search.empty': 'Căutarea dvs. nu a returnat rezultate.',

	'forms.submitted': 'Intrările dvs. au fost trimise cu succes.',
	'forms.errored': 'A apărut o eroare la trimiterea intrărilor.',
	'forms.required': 'Acest câmp de introducere este necesar pentru a trimite formularul.',
	'forms.close': 'mulțumesc',

	'prevnext.prev': 'povestea anterioară',
	'prevnext.next': 'următoarea poveste',

	'navigation.back': 'înapoi',
	
	'share.back': 'înapoi',
	'share.embed': 'Încorporați',
	'share.share': 'Share',
	'share.cover': 'Cover',
	'share.custom': 'element propriu',
	'share.inline': 'încorporat direct',
	'share.customhere': 'A SE INSERA ELEMENTUL DVS. AICI',
	'share.scriptonce': 'Scriptul de mai sus trebuie integrat o singură dată pe pagină',
	'share.FacebookLabel': 'Distribuiți pe Facebook',
	'share.TwitterLabel': 'tweet',
	'share.TwitterText': '{title}',
	'share.EmbedLabel': 'Încorporați',

	'more.showCollection': 'Afișați toate poveștile',
	'more.showMore': 'Afișați povestiri mai vechi',
	'more.showMoreBack': '«',
	'more.showMoreSearch': 'Afișați mai mult conținut',
	'more.showMoreSearchBack': '«',

	'multislider.showAll': 'Afișați toate poveștile',

	'passwordScreen.passwordPlaceholder': 'parolă',
	'passwordScreen.usernamePlaceholder': 'nume utilizator',
	'passwordScreen.subTitle': 'este o {type, select, story {poveste} collection {colecție}} protejată',
	'passwordScreen.submit': 'autentificare',
	'passwordScreen.error': 'Conectarea nu este posibilă!',

	'like.label': '{likeCount, number} Îmi place',
	'like.noLikeLabel': 'Îmi place',

};



// WEBPACK FOOTER //
// ./lib/locales/ro.js